import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function LubeSampleStatus(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [formObj, setFormObj] = useState(FilterObj);
    const [sampleStatus, setSampleSattus] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const { type } = props;
    const autoTextSampleStatus = (event) => {
        //
        let result = [
           
            { id: 'Arrived at the Lab', name: 'Arrived at the Lab' },
            { id: 'Analysed', name: 'Analysed' },
            { id: 'Reported', name: 'Reported' },
            { id: 'Other', name: 'Other' },
        ]
        if (selectedvalue) {
            selectedvalue.forEach((val, i) => {
                result = result.filter((ele) => ele.name != val.name)
            })
        }
        setSampleSattus(result);
        
    }
    const handelChange = (event, newValue, type) => {
        //
        
            props.onChange(newValue);
            const filteredlubesamplestatus = {
                ...formObj,
                lubesamplestatus: newValue
            };
            setFormObj(filteredlubesamplestatus);
            setselectedvalue(newValue);
    }
    const defaultValue = (val) => {
        //
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.lubesamplestatus);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
        autoTextSampleStatus();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.lubesamplestatus || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={sampleStatus}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                onChange={(event, newValue) => handelChange(event, newValue, type)}


                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Sample Status "
                        //placeholder="Favorites"
                        onChange={autoTextSampleStatus}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
